export default {
  accepted_message: "รายการเดิมพันของคุณได้รับการยอมรับแล้ว",
  waiting_message: "การเดิมพันของคุณกำลังรอ",
  login: "โปรดเข้าสู่ระบบเพื่อดำเนินการต่อ......",
  password_rule: "รหัสผ่านต้องประกอบด้วยตัวพิมพ์เล็ก/ใหญ่ และมีความยาวระหว่าง 6 ถึง 10 ตัวอักษร.",
  nickname_rule: "คุณสามารถตั้งชื่อเล่นสำหรับการแสดงผลและเข้าสู่ระบบ (ตัวอักษรหรือตัวเลข 6-15 ตัว) โปรดทราบว่า คุณตั้งชื่อเล่นนี้ได้ครั้งเดียวเท่านั้น คุณไม่สามารถแก้ไขหรือยกเลิกชื่อเล่นนี้เมื่อตั้งค่าแล้ว",
  change_password_succeed: "เปลี่ยนรหัสผ่านสำเร็จ",
  add_secondary_succeed: "ตั้งชื่อเล่นสำเร็จ",
  succeed: "คุณได้ดำเนินการเรียบร้อยแล้ว!",
  failed: "คุณดำเนินการไม่สำเร็จ!",
  no_information_available: "ไม่มีข้อมูล",
  select_display_language: "เลือกภาษาที่คุณต้องการ",
  select_odds_type: "เลือกประเภทการแสดงผลราคาตามที่ต้องการ.",
  select_page_type: "เลือกค่าแสดงผลบนหน้าจอของคุณ ทั้งตลาดวันนี้และตลาดของวันถัดไป.",
  select_show_score_map: "เปิดใช้งานกระดานแสดงคะแนนโดยอัตโนมัติเมื่อมีการวางเดิมพัน.",
  select_default_event_sorting: "เลือกเรียงตามลำดับการแสดงผลเกมส์ตามที่คุณต้องการ.",
  select_market_type: "เลือกตลาดที่คุณต้องการ",
  select_page_size: "เลือกขนาดหน้าเว็บเพจที่คุณต้องการ",
  change_sports_menu_order: "กรุณาลากกีฬาเพื่อเปลี่ยนแปลงคำสั่งที่ต้องการของเมนูกีฬา",
  view_outstanding_bets_in_bet_list: "ยอดเดิมพันค้างชำระอาจต้องใช้เวลาสักครู่เพื่อประมวลผล กรุณาไปที่ รายการวางเดิมพัน เพื่อดูยอดเดิมพันค้างชำระล่าสุดของคุณ",
  time_display_in_gmt_plus_8: "โปรดทราบว่าเวลาที่แสดงอยู่บนพื้นฐาน GMT +8 ชั่วโมง.",
  select_default_stake: "เปิดใช้งานระบบอัตโนมัติป้อนเดิมพันที่คุณกำหนดเอง เงินเดิมพันล่าสุดและจำนวนเงินเดิมพันสูงสุดหรือต่ำสุด.",
  bet_empty: "บิลเดิมพันของคุณว่างเปล่า กรุณาคลิกที่อัตราเดิมพันในตารางเพื่อเลือกการเดิมพัน",
  no_event: "ไม่มีการแข่งขันหรือเกมในขณะนี้ กรุณาเยี่ยมชมกิจกรรมกีฬาหรือเกมอื่น ๆ หรือกลับมาในภายหลัง",
  no_games_available: "ไม่มีเกมที่พร้อมใช้งาน",
  no_bets: "ไม่มีเดิมพันที่กำลังดำเนินการ",
  no_waiting: "ไม่มีเดิมพันที่รอการยอมรับ",
  no_void: "ไม่มีเดิมพันที่เป็นโมฆะ",
  odds_changed: "อัตราต่อรองมีการเปลี่ยนแปลง",
  confirmation: "คุณยืนยันที่จะวางเดิมพันนี้หรือไม่?",
  olderversion: "ตรวจพบเวอร์ชันที่เก่ากว่าคลิกตกลงเพื่ออัพเดตหรือกด Ctrl-F5.",
  gmt8: "โปรดทราบว่าเวลาที่แสดงอยู่บนพื้นฐานGMT +8ชั่วโมง.",
  no_betting_market: "ไม่มีตลาดเดิมพัน",
  note_1: "ยอดเดิมพันค้างชำระอาจต้องใช้เวลาสักครู่เพื่อประมวลผล กรุณาไปที่ รายการวางเดิมพัน เพื่อดูยอดเดิมพันค้างชำระล่าสุดของคุณ",
  match_not_started: "การแข่งขันยังไม่เริ่ม",

  banner1a: "เลือกกีฬา",
  banner1b: "เข้าสู่เกม",
  banner1c:
    "ด้วยกีฬาที่มีให้เลือกมากกว่า 90 รายการและการแข่งขันถ่ายทอดสดหลายพันรายการเพื่อเดิมพัน อะดรีนาลินพลุ่งพล่านไม่มีสิ้นสุด อย่าพลาดโอกาสที่จะชนะด้วยข้อเสนอราคาต่อรองเดิมพันและกีฬายอดนิยมในตลาดของเรา",
  banner2a: "ลองเสี่ยงโชค",
  banner2b: "รับรางวัลใหญ่",
  banner2c:
    "รับรางวัลชนะเลิศขณะที่เพลิดเพลินไปกับประสบการณ์การเล่นเกมคาสิโนที่เข้มข้นและดื่มด่ำในห้องสวีทสุดหรูของเรา นั่งเล่นเกมคาสิโนที่คุณชื่นชอบและช่วงท้ายมีการคุยโต้ตอบจากดีลเลอร์ถ่ายทอดสดที่มีคุณภาพ ทั้งหมดคุณจะได้รับความสะดวกสบายไม่ว่าคุณจะอยู่ที่ใด",
  banner3a: "เกมสุดยอดและคุณภาพ",
  banner3b: "ประสบการณ์แบบใหม่ที่ไม่เคยพบเห็นมาก่อน",
  banner3c: "เกมที่มีให้เลือกมากมายเท่าที่สายตาคุณจะมองเห็น สัมผัสความสนุกโดยตรงตอนนี้",
  banner4a: "OLYMPIC GAMES",
  banner4b: "TOKYO 2020",
  banner4c: "โอลิมปิกฤดูร้อน 2020 หรือชื่ออย่างเป็นทางการว่า Games of the XXXII Olympiad และยังเป็นที่รู้จักในชื่อโตเกียว 2020 เป็นงานกีฬานานาชาติที่กำลังจะจัดขึ้นในระหว่างวันที่ 23 กรกฎาคม ถึง 8 สิงหาคม พ.ศ. 2564 ที่กรุงโตเกียว",
  banner4d: "เรานำยูโรคัพ 2020 กลับมาให้คุณ!",
  banner5a: "ไฮไลท์กีฬาสดและเกม",
  banner5aa: "เข้าถึงชุมชนของคุณแบบเรียลไทม์",
  banner5b: "ดูทีวีสดและไฮไลท์ฟรีที่ดีที่สุดบนเว็บและอุปกรณ์มือถือ",
  banner5c: "รับผลการแข่งขันกีฬาล่าสุดทุกที่ทุกเวลา",

  banner6a: "E-Fighting",
  banner6b: "เล่นเกมต่อสู้ที่ดีที่สุด",
  banner6c: "รวบรวมตัวละครที่คุณชื่นชอบ ล้มลงในการต่อสู้ เข้าสู่สนามรบ และสัมผัสการต่อสู้! ยิ่งเล่นยิ่งชนะ!",

  banner7a: "NEW ESPORTS INTERFACE",
  banner7b: "ALL NEW EXPERIENCE",
  banner7c: "Extensive Choices of Esports markets, Industry Leading Betting Experience.",
  banner7d: "Popular massive multiplayer, Unbeatable odds & speedy settlement.",
  
  banner8a: "V-GAMES",
  banner8b: "PLAY THE GAMES, AND EXPERIENCE A DIFFERENT KIND OF VICTORY.",
  banner8c: "Experience a whole new level of victory.",
  banner8d: "Immerse yourself in a variety of games, from competitive to fighting, and explore new genres that wil keep you engaged for hours.",

  banner10a: "Wishing you a great fun time",
  banner10b: "While you row to the rhythm of roaring drums!",
  
  bannersb: "เพลิดเพลินไปกับความตื่นตาและความตื่นเต้นที่ไม่หยุดนิ่งด้วยการแข่งขันกีฬาที่ไม่มีที่สิ้นสุดเพื่อการเดิมพันทั้งในประเทศและจากทั่วทุกมุมโลก กับเรา เพื่อคุณจะมีอัตราเดิมพันที่ดีที่สุดเสมอ",
  bannersl: "พักสมองจากความเป็นจริงก้าวผ่านและสัมผัสประสบการณ์จินตนาการของตัวเองในเกมเสมือนจริงที่มีรายละเอียดชัดเจน คุณแน่ใจว่าจะได้รับการความประทับใจ",
  bannerlc: "ก้าวเข้ามาในห้องสวีทคาสิโนสุดพิเศษของเราดื่มด่ำไปกับคาสิโนสุดโปรดของคุณและปลดปล่อยตัวเองไปกับประสบการณ์การเล่นโต้ตอบที่มีดีลเลอร์ที่สวยงามถ่ายทอดสด",

  banner11a: "การแข่งขันทีมชาติที่ใหญ่ที่สุดในโลก",
  banner11b: "การแข่งขันฟุตบอลโลก 2022 จะจัดขึ้นในกาตาร์ตั้งแต่วันที่ 20 พฤศจิกายนถึง 18 ธันวาคม 2565",
  banner11c: "มีทีมงานทั้งหมด 32 ทีมรวมถึงโฮสต์กาตาร์มีคุณสมบัติในการแข่งขันซึ่งจะเป็นเหตุการณ์ที่ยิ่งใหญ่ที่สุดของฟุตบอลครั้งแรกที่เกิดขึ้นในตะวันออกกลาง",

  join_us1: "ทำให้โลกของคุณมีความหมาย",
  join_us2:
    "ด้วยการกระทำตลอดเวลา 24ชั่วโมงของเรา และผลิตสิ่งที่น่าตื่นเต้นมามากมายเพื่อที่จะเดิมพัน เราให้ความสำคัญกับความชอบทุกประเภทของคุณนอกจากนี้เรายังมีโบนัส การส่งเสริมการขายอย่างต่อเนื่องและการจ่ายเงินอย่างมีประสิทธิภาพเพื่อให้คุณเพลิดเพลินกับประสบการณ์การเล่นเกมที่ดีที่สุด ทำตามขั้นตอนแรกและสมัครกับเราตอนนี้เร็ว ง่ายและฟรี",
  join_us3: "เข้าร่วมกับเราตอนนี้",

  icon1a: "เหมาะสำหรับมือถือ",
  icon1b: "เกมของเราสามารถเข้าถึงได้บนแพลตฟอร์มมือถือยอดนิยมดังนั้นคุณสามารถเล่นเกมได้ทุกที่บนอุปกรณ์ที่คุณชื่นชอบ",
  icon2a: "ความปลอดภัยและการสนับสนุนขั้นสูง",
  icon2b: "สนุกกับเกมของเราและทำธุรกรรมกับเราด้วยความอุ่นใจที่แท้จริง - เว็บไซต์ของเราปลอดภัยอย่างเต็มที่เพื่อปกป้องความเป็นส่วนตัวและข้อมูลส่วนบุคคลของคุณ",
  icon3a: "ประสบการณ์ที่น่าประทับใจ",
  icon3b: "เลือกตามใจชอบ ใช้งานง่ายและมีการโต้ตอบ - เราได้คัดสรรและคัดสรรผลิตภัณฑ์พรีเมี่ยมที่คัดสรรแล้วซึ่งจะมอบความตื่นเต้นที่คุณแสวงหา",
  icon4a: "สนับสนุนลูกค้า",
  icon4b: "ความพึงพอใจของคุณคือสิ่งที่เราให้ความสำคัญ เรายินดีรับฟังจากคุณหากคุณมีข้อเสนอแนะหรือข้อสงสัยใด ๆ ที่จะช่วยให้เราบริการคุณได้ดียิ่งขึ้น",
  footer1a: "กำหนดอายุผู้เล่น",
  footer1b:
    "การพนันเป็นสิ่งผิดกฎหมายสำหรับเด็กอายุต่ำกว่า 18 ปีทุกรัฐห้ามมิให้เล่นการพนัน โดยผู้เยาว์การชนะเลิศจะดำเนินการตรวจสอบอายุแบบสุ่มและเงินรางวัลจะถูกริบหากนักพนันอายุต่ำกว่า 18 ปี© 2004-2019. {fvalue} เป็นเครื่องหมายการค้าจดทะเบียนระดับสากล (Bookmaker Sports ที่ได้รับอนุญาต) สงวนลิขสิทธิ์.",

  contactus_title1: "ผู้เชี่ยวชาญด้านการบริการลูกค้าพร้อมที่จะตอบคำถามของคุณทั้งหมดรวมถึงข้อกังวลในการชำระเงินเป็นภาษาอังกฤษและภาษาจีน",
  contactus_title2: "อาจมีการคิดค่าโทรระหว่างประเทศ การโทรศัพท์ถึงเราอาจถูกบันทึกไว้เพื่อการคุ้มครองลูกค้าการตรวจสอบข้อมูลวัตถุประสงค์การประกันคุณภาพและการปฏิบัติตามกฎระเบียบ",

  days: "วัน",
  hours: "ชั่วโมง",
  mins: "นาที",
  secs: "วินาที",
  ldiff_changed: "Percent has changed",
  no_room: "ไม่มีห้องว่าง โปรดเลือกตัวเลือกอื่นแล้วค้นหาอีกครั้งหรือกลับมาใหม่ในภายหลัง",
  people_in_this_room: "คนในห้องนี้",
  room_full: "ห้องนี้เต็ม",
  room_joined: "คุณได้เข้าร่วมห้องนี้",
  my_room: "ห้องฉัน",
  pin_code: "เช่น: 123456",
  no_matches: "ไม่มีแมตช์หรือเกมใดๆ ในตอนนี้",
  are_you_sure: "คุณแน่ใจหรือไม่ว่าจะดำเนินการนี้ต่อ",
  accept_terms: "การทำเครื่องหมายแสดงว่าคุณยืนยันว่าคุณได้อ่าน ทำความเข้าใจ และยอมรับข้อกำหนดและเงื่อนไขด้านบน",
  accept_required: "โปรดอ่าน ทำความเข้าใจ และยอมรับ<br />ข้อกำหนดและเงื่อนไขด้านบนก่อนดำเนินการต่อ",
  must_accept_better_odds: "โดยค่าเริ่มต้น การวางเดิมพันจะยอมรับอัตราต่อรองที่ดีกว่าโดยอัตโนมัติ โปรดดูข้อกำหนดและเงื่อนไขสำหรับข้อมูลเพิ่มเติม",
  maintenance_notice: "ขณะนี้ เรากำลังดำเนินการบำรุงรักษาระบบ โปรดลองอีกครั้งในภายหลัง",
  not_winning_prize_in_this_tournament: "ไม่ได้รับรางวัลในทัวร์นาเมนต์นี้",
  you_did_not_join_this_room: "คุณไม่ได้เข้าร่วมห้องนี้",
  deduct_confirm: "การดำเนินการนี้จะเริ่มเกมและเครดิตของคุณจะถูกหัก<br />คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อหรือไม่",
  over_max_match: "การแข่งขันในลีกนี้เกินจำนวนการแข่งขันสูงสุดที่เลือกได้<br />โปรดขยายลีกและเลือกการแข่งขันที่ต้องการ",

  //tournament
  button_skip: "ข้ามทัวร์",
  button_previous: "ก่อนหน้า",
  button_next: "ถัดไป",
  button_stop: "เสร็จสิ้น",
  button_continue: "ดำเนินการต่อ",
  tour_content_1: "<h6>ยินดีต้อนรับสู่การแข่งขัน WBET</h6><p>เรายินดีที่จะประกาศการแข่งขันใหม่ที่น่าตื่นเต้นสำหรับผู้สนับสนุนเว็บไซต์ของเราโดยเฉพาะ</p>",
  tour_content_2: "<h6>ห้องสาธารณะ</h6><p>สมาชิกมีส่วนร่วมในการเล่นเกมแข่งขันกันเอง โดยมักจะมีค่าธรรมเนียมแรกเข้า</p>",
  tour_content_3: "<h6>ห้องส่วนตัว</h6><p>สมาชิกสามารถเปิดห้องเพื่อเล่นกับเพื่อนได้โดยใช้พินที่ได้รับเชิญเพื่อเข้าร่วม</p>",
  tour_content_4: "<h6>ห้องสาธารณะฟรี</h6><p>จัดโดยองค์กรต่างๆ ในช่วงกิจกรรมพิเศษเฉพาะสำหรับสมาชิก โดยเสนอการมีส่วนร่วมฟรี</p>",
  tour_content_5: "<h6>ผู้เล่นทั้งหมดสามารถเข้าร่วมและเรียกเก็บเงินได้</h6><p>ผู้เล่น : ความจุของห้อง</p><p>ค่าธรรมเนียมแรกเข้า: ข้อเสนอพิเศษตามห้อง ( สกุลเงินของเจ้าของบัญชี)</ พี>",
  tour_content_6: "<h6>รายละเอียดห้อง</h6><p>คลิกที่นี่เพื่อดูสถิติห้องและเข้าร่วมห้อง</p>",
  tour_content_7: "<h6>รายละเอียดพูล</h6><p>รางวัลพูลรวมสำหรับผู้ชนะ & รหัสห้องที่ไม่ซ้ำกันเพื่อค้นหา</p>",
  tour_content_8: "<h6>รายละเอียดการเริ่มห้อง</h6><p>สถานะห้องและเวลาเข้าร่วมล่าสุดที่แสดง</p>",
  tour_content_9: "<h6>สร้างห้องส่วนตัว</h6><p>เพื่อสร้างการเล่นห้องส่วนตัวและเชิญเพื่อนเข้าร่วมโดยปักหมุดเพื่อเข้าร่วม</p>",
  tour_content_10: "<h6>อันดับคะแนน</h6><p>คุณลักษณะนี้จะแสดงคะแนนสำหรับผู้เล่นที่ดูและติดตามผล</p>",

  time_machine_information_HDP: "WBET Time Machine [HDP] ใช้สำหรับทำนายว่าทีมใดจะทำประตูได้มากที่สุดในช่วงเวลาที่เลือก",
  time_machine_information_OU: "WBET Time Machine [OU] ใช้สำหรับทำนายจำนวนประตูรวมในช่วงเวลาที่เลือก"

};
